import React, { useEffect } from 'react';

const StripeDonationButton = ({ className = '' }) => {
  useEffect(() => {
    // Ensure Stripe script is loaded
    if (!window.customElements.get('stripe-buy-button')) {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/buy-button.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div className={`stripe-button-wrapper ${className}`}>
      <stripe-buy-button
        buy-button-id="buy_btn_1TKifdRtRC2BEgeXLANnNDwD"
        publishable-key="pk_live_51TK5CLRtRC2BEgeXWkK8SLAR5tYk3Pm7D2Lw76ZEQQqFdxnpOhl25lSVHip7F05RebYEiVnrZ7lDTpZo7PATUKQ000foRtDjdy"
      >
      </stripe-buy-button>
    </div>
  );
};

export default StripeDonationButton;
